import React from "react";
import { Box } from "@mui/material";
import { ProjectsHighlights } from "../components/projectsHighlights/ProjectsHighlights";

export const Homepage: React.FC = () => {
  return (
    <Box sx={{ overflow: "hidden" }}>
      <ProjectsHighlights
        disableProjectRandomization={true}
        highlightedOnly={true}
        disableSortById={true}
      ></ProjectsHighlights>
    </Box>
  );
};
